"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IsDeprecated = exports.GetPhotoAnimation = exports.GetTemplate2List = exports.GetAllTemplates = exports.GetTemplate = void 0;

var _object = require("lodash/object");

var _all = require("animations-json/build/all");

var template2Configs = Object.values((0, _all.getAllTemplateConfig)());

var all = _all.Templates.concat(_all.Outros, template2Configs);

var GetTemplate = function GetTemplate(name) {
  return all[(0, _object.findKey)(all, {
    name: name
  })];
};

exports.GetTemplate = GetTemplate;

var GetAllTemplates = function GetAllTemplates() {
  return all;
};

exports.GetAllTemplates = GetAllTemplates;

var GetTemplate2List = function GetTemplate2List() {
  return template2Configs;
};

exports.GetTemplate2List = GetTemplate2List;

var GetPhotoAnimation = function GetPhotoAnimation(id) {
  return _all.PhotoAnimations[(0, _object.findKey)(_all.PhotoAnimations, {
    id: id
  })];
};

exports.GetPhotoAnimation = GetPhotoAnimation;

var IsDeprecated = function IsDeprecated(name) {
  var template = all[(0, _object.findKey)(all, {
    name: name
  })];
  return !!template.isDeprecated;
};

exports.IsDeprecated = IsDeprecated;